import React, { useEffect, useMemo, useState } from "react";
import api from "../../services/apiService";
import styles from "./styles.module.css";

const SeletorFiltrosPerfilEleitorado = ({
  filtrosSelecionados,
  setFiltrosSelecionados,
}) => {
  const [categorias, setCategorias] = useState([]);
  const [valores, setValores] = useState([]);
  const [erroLocal, setErroLocal] = useState("");
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    const carregarOpcoes = async () => {
      setCarregando(true);
      setErroLocal("");

      try {
        const [categoriasResponse, valoresResponse] = await Promise.all([
          api.get("/selects/listar-categorias-perfil-eleitorado"),
          api.get("/selects/listar-valores-perfil-eleitorado"),
        ]);

        setCategorias(categoriasResponse.categorias || []);
        setValores(valoresResponse.valores || []);
      } catch (error) {
        setErroLocal(error.message || "Erro ao carregar filtros de perfil.");
      } finally {
        setCarregando(false);
      }
    };

    carregarOpcoes();
  }, []);

  const valoresPorCategoria = useMemo(() => {
    return valores.reduce((acc, item) => {
      if (!acc[item.categoria]) {
        acc[item.categoria] = [];
      }

      acc[item.categoria].push(item);
      return acc;
    }, {});
  }, [valores]);

  const alternarValor = (categoria, idTipoPerfil) => {
    const selecionadosDaCategoria = filtrosSelecionados[categoria] || [];
    const jaSelecionado = selecionadosDaCategoria.includes(idTipoPerfil);

    const novaLista = jaSelecionado
      ? selecionadosDaCategoria.filter((id) => id !== idTipoPerfil)
      : [...selecionadosDaCategoria, idTipoPerfil];

    const novoEstado = {
      ...filtrosSelecionados,
      [categoria]: novaLista,
    };

    if (!novaLista.length) {
      delete novoEstado[categoria];
    }

    setFiltrosSelecionados(novoEstado);
  };

  if (carregando) {
    return <div className={styles.status}>Carregando filtros de perfil...</div>;
  }

  if (erroLocal) {
    return <div className={styles.erro}>{erroLocal}</div>;
  }

  return (
    <div className={styles.container}>
      <h3 className={styles.titulo}>Filtros de Perfil</h3>
      <p className={styles.subtitulo}>
        Selecione valores em uma ou mais categorias para combinar os filtros.
      </p>

      {!categorias.length && (
        <div className={styles.status}>Nenhuma categoria de perfil encontrada.</div>
      )}

      <div className={styles.gradeCategorias}>
        {categorias.map((itemCategoria) => {
          const categoria = itemCategoria.categoria;
          const opcoes = valoresPorCategoria[categoria] || [];
          const selecionados = filtrosSelecionados[categoria] || [];

          return (
            <section key={categoria} className={styles.cardCategoria}>
              <h4 className={styles.nomeCategoria}>{categoria}</h4>

              {!opcoes.length && (
                <div className={styles.statusPequeno}>
                  Sem valores disponiveis para esta categoria.
                </div>
              )}

              {opcoes.map((opcao) => (
                <label key={opcao.id_tipo_perfil} className={styles.opcao}>
                  <input
                    type="checkbox"
                    checked={selecionados.includes(opcao.id_tipo_perfil)}
                    onChange={() => alternarValor(categoria, opcao.id_tipo_perfil)}
                  />
                  <span>{opcao.descricao}</span>
                </label>
              ))}
            </section>
          );
        })}
      </div>
    </div>
  );
};

export default SeletorFiltrosPerfilEleitorado;
